module.exports = __webpack_public_path__ + "static/media/LELE01.711c645d.jpg";